export default {
      id: "googledcm-usage",
      viewBox: "0 0 18 18",
      url: "static/docker-35e621d613051bbda5b8b67fc5bb152e/images/" + "sprite.svg#googledcm-usage",
      toString: function () {
        return this.url;
      }
    }